import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";

Vue.use(Vuex);

const queryString = location.search;
const params = new URLSearchParams(queryString);

export default new Vuex.Store({
	state: () => ({
		couponCode: null,
		planId: null,
		utm: {},
		shopify: null,
		shopify_redirect: false,
		organization_size: params.get("size") ?? null,
		display_organization_size_radio: params.get("size") ? false : true,
		isLicensed: false,
		accountManagerUrl: "https://account.sinao.app"
	}),
	mutations: {
		shopify_redirect(state, payload) {
			state.shopify_redirect = payload;
		},
		couponCode(state, payload) {
			state.couponCode = payload;
		},
		planId(state, payload) {
			state.planId = payload;
		},
		utm(state, payload) {
			state.utm = payload;
		},
		shopify(state, payload) {
			state.shopify = payload;
		},
		organization_size(state, payload) {
			state.organization_size = payload;
		},
		setIsLicensed(state, payload) {
			state.isLicensed = payload;
		},
		setAccountManagerUrl(state, payload) {
			state.accountManagerUrl = payload;
		}
	},
	actions,
	strict: process.env.NODE_ENV !== "production"
});
